import { render, staticRenderFns } from "./OfficialInfoPage.vue?vue&type=template&id=7c6aad20&"
import script from "./OfficialInfoPage.vue?vue&type=script&lang=js&"
export * from "./OfficialInfoPage.vue?vue&type=script&lang=js&"
import style0 from "./OfficialInfoPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports